import { useNavigate, useLocation } from "react-router-dom";
import { usePortalData } from "../context/PortalDataContext";

const NAV_ITEMS = [
  { label: "Home",        icon: "pi-home",      path: "/"              },
  { label: "Rx",          icon: "pi-file-edit", path: "/prescriptions" },
  { label: "Refills",     icon: "pi-refresh",   path: "/refills",      badge: true },
  { label: "Upload",      icon: "pi-upload",    path: "/upload"        },
  { label: "Profile",     icon: "pi-user",      path: "/profile"       },
];

export default function MobileBottomNav() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { pendingRefillCount } = usePortalData();

  return (
    <nav className="mobile-bottom-nav">
      <div className="mobile-bottom-nav-inner">
        {NAV_ITEMS.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== "/" && location.pathname.startsWith(item.path));

          const badgeCount = item.badge ? pendingRefillCount : 0;

          return (
            <button
              key={item.path}
              className={`mobile-nav-item ${isActive ? "active" : ""}`}
              onClick={() => navigate(item.path)}
            >
              <i className={`pi ${item.icon}`} />
              <span>{item.label}</span>
              {badgeCount > 0 && (
                <span className="mobile-nav-badge">{badgeCount}</span>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
